import { TextField } from '../../atoms';
import { FORM_CLASSIFIERS_EAVP_LOAD_EDIT } from '../../constants/formKeys';
import {
  getClassifiersEAVPLoadChange,
  getClassifiersEAVPLoadItem,
  getClassifiersEAVPLoadItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { eavpLoadDataCron } from '../../constants/parameters';
import createParameterEditor from '../createParameterEditor';

export default createParameterEditor({
  title: 'parameterEAVPLoadCronTitle',
  formKey: FORM_CLASSIFIERS_EAVP_LOAD_EDIT,
  fields: [
    {
      name: eavpLoadDataCron.VALUE,
      label: 'fieldEAVPLoad',
      component: TextField,
      className: 'date-field',
    },
  ],
  fetchAction: actions.fetchClassifierEAVPLoad,
  changeAction: actions.changeClassifierEAVPLoad,
  getChangeSelector: getClassifiersEAVPLoadChange,
  getItemSelector: getClassifiersEAVPLoadItem,
  getInitialValues: (state) => ({
    [eavpLoadDataCron.VALUE]: getClassifiersEAVPLoadItemData(state),
  }),
});
